var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrizesMenuWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68497 8.69447C4.75559 11.5225 7.02322 13.9973 9.8521 13.9973V13.9973V13.9973C12.7254 13.9973 14.939 11.5624 15.0178 8.69019C15.0275 8.33696 15.0326 7.98115 15.0326 7.62277C15.0326 5.92904 14.9295 4.27323 14.7544 2.70517C14.6907 2.13423 14.2608 1.67219 13.6941 1.57749C12.4523 1.36996 11.1779 1.24829 9.8521 1.24829C8.52333 1.24829 7.22588 1.36284 5.9895 1.57425C5.43267 1.66947 5.01172 2.12392 4.9471 2.68511C4.76624 4.25562 4.67157 5.92279 4.67157 7.62277C4.67157 7.9827 4.67612 8.33992 4.68497 8.69447Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68497 8.69447C4.75559 11.5225 7.02322 13.9973 9.8521 13.9973V13.9973V13.9973C12.7254 13.9973 14.939 11.5624 15.0178 8.69019C15.0275 8.33696 15.0326 7.98115 15.0326 7.62277C15.0326 5.92904 14.9295 4.27323 14.7544 2.70517C14.6907 2.13423 14.2608 1.67219 13.6941 1.57749C12.4523 1.36996 11.1779 1.24829 9.8521 1.24829C8.52333 1.24829 7.22588 1.36284 5.9895 1.57425C5.43267 1.66947 5.01172 2.12392 4.9471 2.68511C4.76624 4.25562 4.67157 5.92279 4.67157 7.62277C4.67157 7.9827 4.67612 8.33992 4.68497 8.69447Z",
    stroke: "white",
    strokeWidth: 1.88571
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85168 14.0073V18.085",
    stroke: "white",
    strokeWidth: 1.88571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6142 18.085H13.0899",
    stroke: "white",
    strokeWidth: 1.88571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7094 2.54321H16.924C17.6679 2.54321 18.271 3.14626 18.271 3.89015V4.12801C18.271 5.38895 17.8616 6.59824 17.133 7.48986C16.558 8.19338 15.8215 8.65364 15.0301 8.81654",
    stroke: "white",
    strokeWidth: 1.88571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9599 2.54333H2.79075C2.04686 2.54333 1.44382 3.14638 1.44382 3.89027V4.12813C1.44382 5.38907 1.85317 6.59836 2.58182 7.48998C3.15358 8.18961 3.88518 8.64868 4.6716 8.81394",
    stroke: "white",
    strokeWidth: 1.88571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizesMenuWhite);
export default __webpack_public_path__ + "static/media/prizes-menu-white.099d08208cf74a8ae22210c934fae4c9.svg";
export { ForwardRef as ReactComponent };